import { constrain, toDeg } from "../../../utils/spatial";
import { BaseVisual } from "../../../visuals/BaseVisual";
import { DragonflyVisual } from "../../../visuals/DragonflyVisual";
import { CameraConfig, ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { WREvents } from "../../WREvents";
import { SimAgentUpdate } from "../scenarios/ScenarioClient";
import { BaseAgent } from "./BaseAgent";
import { CameraController } from "./dragonfly/CameraController";
import { DragonflyStateManager } from "./dragonfly/DragonflyStateManager";
import * as THREE from 'three';
import { C4Visual } from "../../../visuals/C4Visual";
import { C4Agent } from "./C4Agent";

export interface TargetingInfo {
  visual: ModelBasedVisual;
  isAlive: boolean;
  isServiced: boolean;
  acquiredTime: number;
}

export class DragonflyAgent extends BaseAgent {
  manager: DragonflyStateManager;
  dfv: DragonflyVisual;
  public inSentryMode = false;
  public targets = new Map<BaseVisual, TargetingInfo>();
  public nextTarget?: TargetingInfo;
  public c4?: C4Visual;
  cameraController: CameraController;
  cameraConfig: CameraConfig =
    {
      name: "Dragonfly Camera",
      parent: new THREE.Group(),
      position: new THREE.Vector3(0, 0, 0),
      rotation: new THREE.Euler(0, - Math.PI / 2, -Math.PI / 2),
      fov: 10
    };

  constructor(visual: DragonflyVisual) {
    super(visual);
    this.dfv = visual;
    this.manager = new DragonflyStateManager(this);
    this.cameraConfig.parent = this.manager.cameraGimbal;
    this.cameraController = this.manager.cameraController;
    this.updateCamera(false);
    this.addState('Sentry Mode', async () => {
      if (this.c4) {
        (this.c4.agent as C4Agent).disableState('Container on');
      }
      this.setSentry(true);
      return true;
    }, async () => {
      // if (this.c4) {
      //   (this.c4.agent as C4Agent).enableState('Container on');
      // }
      this.setSentry(false);
    });
    // this.enableState('Stage');
  }

  public async setup() {
    this.c4 = this.visual.wr.dataService.findVisualsByType('C4Visual')[0] as C4Visual;
    console.log({ c4: this.c4 });
  }

  private updateCamera(live: boolean) {
    (this.visual as DragonflyVisual)._cameraConfigs = [this.cameraConfig];
    if (live) {
      this.visual.wr.emitEvent(WREvents.CameraSelected, null);
      this.visual.wr.emitEvent(WREvents.CameraSelected, this.visual, 0);
    }
  }

  private lastFovUpdate = Date.now();
  public async loop(): Promise<void> {
    if (!this.inSentryMode) return;
    if (!this.c4) return;
    if (this.visual.obj.position.z < 10) return;
    let distanceFromCamera = Number.MAX_VALUE;
    let distance = Number.MAX_VALUE;
    for (const visual of this.visual.wr.dataService.visuals.values()) {
      if (visual.obj.visible && visual.id.startsWith('Shahed') && !this.targets.has(visual)) {
        distance = this.c4.obj.position.distanceTo(visual.obj.position);
        if (distance < 220) {
          const target = {
            visual: visual as ModelBasedVisual,
            isAlive: true,
            isServiced: false,
            acquiredTime: Date.now()
          };
          this.targets.set(visual, target);
          // this.cameraController.isTracking = true;
          // this.cameraController.targetId = visual._id;
          // this.updateCamera(true);
        }
      }
    }
    const next = Array.from(this.targets.values())
    .filter(t => t.isAlive && !t.isServiced)
    .sort((a, b) => {
      const da = this.visual.obj.position.distanceTo(a.visual.obj.position);
      const db = this.visual.obj.position.distanceTo(b.visual.obj.position);
      return da - db;
    })[0];
    if (next && next !== this.nextTarget) {
      this.nextTarget = next;
      this.cameraController.isTracking = true;
      this.cameraController.setTargetId(this.nextTarget.visual._id);
      this.updateCamera(true);
    }
    if (!this.nextTarget) return;
    if (!this.nextTarget.isAlive) {
      this.nextTarget = undefined;
      this.visual.wr.emitEvent(WREvents.CameraSelected, null);
      return;
    }
    if (this.nextTarget.isAlive && !this.nextTarget.isServiced && (Date.now() - this.nextTarget.acquiredTime) > 4000) {
      this.nextTarget.isServiced = true;
      (this.c4.agent as C4Agent).fire(this.nextTarget.visual, (t: BaseVisual) => {
        const target = this.targets.get(t)!;
        target.isAlive = false;
        (target.visual.agent as BaseAgent).enableState('Hidden');
      });
    }
    // if (!this.nextTarget) return;
    distanceFromCamera = this.visual.obj.position.distanceTo(this.nextTarget.visual.obj.position);
    distance = this.c4.obj.position.distanceTo(this.nextTarget.visual.obj.position);
    const fov = Math.floor(constrain(toDeg(Math.atan(10 / distanceFromCamera)), 1, 15));
    this.cameraConfig.fov = fov;
    // if (fov !== this.cameraConfig.fov && (Date.now() - this.lastFovUpdate) > 5000) {
    //   this.lastFovUpdate = Date.now();
    //   this.updateCamera(true);
    // }
    // debugger;
    const displayData = {
      Target: this.nextTarget.visual.id,
      Distance: Math.floor(distance),
      Targeted: this.nextTarget.isServiced ? 'Yes' : 'No',
    };
    // console.log(displayData);
    this.visual.wr.emitEvent(WREvents.CameraOverlayUpdate, this.visual, 0, displayData);
  }


  public setSentry(on: boolean) {
    this.inSentryMode = on;
    this.targets.clear();
    this.visual.wr.emitEvent(WREvents.CameraSelected, null);
    this.cameraConfig.fov = 60;
    this.updateCamera(false);
    if (on) {

    } else {
      this.cameraController.targetObj = undefined;
      this.cameraController.targetId = '';
    }
  }

  public render(delta: number): boolean {
    this.manager.render(delta);
    return true;
  }

  public onSimUpdate(update: SimAgentUpdate): void {
    // don't do nothin
  }
}